import { VxeUI } from 'vxe-pc-ui';

const notification = (msg, status, title) => {
    const options = {
        content: msg,
        status,
    };
    if (title) {
        options.title = title;
    }
    return VxeUI.modal.notification(options);
};

export const custom = (msg, icon, title = '') => {
    const options = {
        content: msg,
        iconStatus: icon,
    };
    if (title) {
        options.title = title;
    }
    return VxeUI.modal.notification(options);
};

export const info = (msg, title = '') => {
    return notification(msg, 'info', title);
};
export const warning = (msg, title = '') => {
    return notification(msg, 'warning', title);
};

export const question = (msg, title = '') => {
    return notification(msg, 'question', title);
};

export const success = (msg, title = '') => {
    return notification(msg, 'success', title);
};

export const error = (msg, title = '') => {
    return notification(msg, 'error', title);
};

export const loading = (msg, title = '') => {
    return notification(msg, 'loading', title);
};
